export const get_dashboard = "super-admin/getDashboardDetails"